@if (showHeader) {
  <div class="actionbar">
    @if (enableCreate) {
      <span class="btCreate">
        <button mat-icon-button (click)="_onCreateClick()"><mat-icon>note_add</mat-icon></button>
      </span>
    }
    @if (enableApprove) {
      <span class="btApprove">
        <button
          matButton="filled"
          [disabled]="!_hasRowsSelected()"
          (click)="_onApproveRejectClick()"
        >
          <language key="DatatableApprove" defaultValue="Approve / Reject"></language></button
      ></span>
    }
    @if (enableReject) {
      <span class="btReject">
        <button
          matButton="filled"
          class="mat-filled-button-error-color"
          [disabled]="!_hasRowsSelected()"
          (click)="_onApproveRejectClick()"
        >
          <language key="DatatableReject" defaultValue="Reject"></language></button
      ></span>
    }
    @for (item of actionBarItemsLeft; track item) {
      <span>
        @if (item.theme === 'raised') {
          <button
            mat-raised-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <span>{{ item.displayname }}</span>
          </button>
        }
        @if (item.theme === 'flat') {
          <button
            mat-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <span>{{ item.displayname }}</span>
          </button>
        }
        @if (item.theme === 'icon') {
          <button
            mat-icon-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
          </button>
        }
      </span>
    }
    @if (showActionBarSpacer) {
      <div class="actionbar-spacer"></div>
    }
    @for (item of actionBarItemsRight; track item) {
      <span>
        @if (item.theme === 'raised') {
          <button
            mat-raised-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <span>{{ item.displayname }}</span>
          </button>
        }
        @if (item.theme === 'flat') {
          <button
            mat-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <span>{{ item.displayname }}</span>
          </button>
        }
        @if (item.theme === 'icon') {
          <button
            mat-icon-button
            [color]="item.type"
            (click)="_onActionClick(item)"
            matTooltip="{{ item.description }}"
            [disabled]="isActionBarItemDisabled(item)"
            [hidden]="isActionBarBrotherInvisible(item)"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
          </button>
        }
      </span>
    }

    @if (enableEdit) {
      <button
        mat-icon-button
        class="btEdit"
        (click)="_onEditClick()"
        [disabled]="_selectedRowsLength() !== 1"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if (enableDelete) {
      <button
        mat-icon-button
        class="btDelete"
        (click)="_onDeleteClick()"
        [disabled]="!_hasRowsSelected()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }
    @if (_parent.placeFilterInDatatableHeader) {
      <smd-filter
        [selectedSearchScope]="_parent.selectedSearchScope"
        (selectedSearchScopeChange)="
          _parent.selectedSearchScope = $event; _parent.refreshSearchScope()
        "
        [(filterValue)]="filterValue"
        (filterChange)="_parent._onFilter()"
        [title]="title"
        [searchScopeConfigs]="_parent.searchScopeConfigs"
        [enableFilter]="enableFilter"
        [enableFilterbuilder]="enableFilterbuilder"
        [appearance]="'fill'"
      ></smd-filter>
    }
    @if (enableRecent && enableFilter) {
      <span class="recent">
        <button mat-raised-button color="primary" (click)="_onRecentClick()">
          <mat-icon>history</mat-icon
          ><language key="DatatableShowRecent" defaultValue="Recent"></language>
        </button>
      </span>
    }
    @if (enableRecent && !enableFilter) {
      <span class="recent search">
        <button mat-raised-button color="primary" (click)="_onSearchClick()">
          <mat-icon>search</mat-icon
          ><language key="DatatableShowSearch" defaultValue="Search"></language>
        </button>
      </span>
    }
    @if (listviewActionButtons) {
      <span class="listviewActionButtons">
        @for (ab of listviewActionButtons; track ab) {
          <button
            mat-icon-button
            (click)="ab.action()"
            matTooltip="{{ _parent.getCaughtObservable(ab?.tooltip) | async }}"
          >
            <mat-icon>{{ ab.icon }}</mat-icon>
          </button>
        }
      </span>
    }
    @if (enableCSVExport) {
      <span class="btCSVExport">
        <button
          mat-stroked-button
          (click)="_onDownloadAsCSVClick()"
          [disabled]="_parent.displayedTotalCount == 0"
        >
          <language key="DatatableCSVExport" defaultValue="CSV"></language>
          <mat-icon aria-hidden="true">get_app</mat-icon>
        </button>
      </span>
    }
  </div>
}
